import type { PublishRequestRecord } from './types';

export function adaptPublishRequestRecord(raw: unknown): PublishRequestRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<PublishRequestRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    page_id: String(data.page_id || ''),
    status: (data.status === 'approved' || data.status === 'rejected') ? data.status : 'pending',
    requested_by: String(data.requested_by || ''),
    reviewed_by: data.reviewed_by ? String(data.reviewed_by) : null,
    notes: data.notes ? String(data.notes) : undefined,
    created_at: String(data.created_at || ''),
    reviewed_at: data.reviewed_at ? String(data.reviewed_at) : null,
  };
}

export function adaptPublishRequestRecordList(raw: unknown): PublishRequestRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptPublishRequestRecord);
}
